angular.module('app').directive("uploadFile", [
    '$rootScope',
    function ($rootScope) {
        return {
            restrict: "A",
            scope: {
                uploadFile: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    scope.$apply(function () {
                        scope.uploadFile = ""
                    });
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.uploadFile = loadEvent.target.result;
                            $rootScope.$broadcast("image:uploaded");
                        });
                        /*scope.$digest(scope.uploadFile = loadEvent.target.result)*/
                    };
                    reader.onerror = function () {
                        scope.$apply(function () {
                            scope.uploadFile = ""
                        });
                    };
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);